import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AutomationsService, TasksService } from '@hosty-app/services';

import { AutomationsStoreEffects } from './automations-store.effects';
import { automationsStoreFeatureKey, reducer } from './automations-store.reducers';

export function provideAutomationsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(automationsStoreFeatureKey, reducer),
    provideEffects([AutomationsStoreEffects]),
    AutomationsService,
    TasksService,
  ]);
}
